import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";
import authReducer from "../pages/Auth/slice"; 

const saga = createSagaMiddleware();

export const store = configureStore({
  reducer: { auth: authReducer },
  middleware: (gdm) => gdm({ thunk: false }).concat(saga),
});
saga.run(rootSaga);
